class VideoPlayer extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els?.video?.exists) return

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.els?.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })

    this.els?.close?.elements.forEach((closeEl) => {
      this.listeners.add(closeEl, 'click', this.handleClose)
    })
  }

  handleTrigger () {
    this.els.modal.element.showModal()
    document.body.classList.toggle('util-SiteOverfloewd', true)

    for (const source in this.els.video.element.children) {
      const videoSource = this.els.video.element.children[source]

      if (
        typeof videoSource.tagName === 'string' &&
        videoSource.tagName === 'SOURCE'
      ) {
        videoSource.src = videoSource.dataset.src
      }
    }

    this.els.video.element.load()
    this.els.video.element.play()
  }

  handleClose () {
    this.els.modal.element.close()
    document.body.classList.toggle('util-SiteOverflowed', false)

    this.els.video.element.pause()
  }
}

if (!customElements.get('video-player')) {
  customElements.define('video-player', VideoPlayer)
}
